require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./forelasning-om-relativitetsteori.json") })
        }
      }, "path---forelasning-om-relativitetsteori");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---forelasning-om-relativitetsteori!./.cache/json/forelasning-om-relativitetsteori.json
// module id = 484
// module chunks = 231608221292675